
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/home/runner/work/app/app/sentry.client.config.ts")
            }
          });